import GoogleMapContainer from "../../../../Component/Miscellaneous/Maps/GoogleMap/GoogleMap"

const GoogleMap = () => {
  return (
    <div className='page-body'>
      <GoogleMapContainer />
    </div>
  )
}

export default GoogleMap